// Configuration values for time blocks and workload regimes.
// @/src/config/planningConfig.js

/**
 * Defines the standard planning time blocks for a day.
 * Each regime is an object with a start and end time in 'HH:mm' format.
 */
export const PLANNING_REGIMES = [
  { start: '09:00', end: '13:30' },
  { start: '13:30', end: '18:00' },
  { start: '18:00', end: '22:30' },
];

/** Day-view capacity pill max. Deliberately below 3 × regime max — a full day rarely fills every regime. */
export const DAY_VIEW_CAPACITY_HOURS = 8;

/**
 * The maximum number of hours that can be effectively planned within a single slot.
 * This represents the productive capacity, accounting for breaks, context switching, etc.
 * @type {number}
 */
export const MAX_PLAN_CAPACITY_HOURS = 3.5;

/**
 * The percentage of the maximum plan capacity that is considered a "healthy" or sustainable target.
 * Planning beyond this threshold might indicate over-scheduling.
 * @type {number} - A value between 0 and 1.
 */
export const HEALTHY_TARGET_PERCENTAGE = 0.8;
